module.exports = __webpack_public_path__ + "fa2001ebb2b35324d2cdc1fea268d900.jpg";